module.exports = __webpack_public_path__ + "media/images/countryrect/pn-715e487793533cd5ecee206191e8fe1d.svg";